export const iconFontAwesomeCodingBugSlash = (
	<i className="fa-solid fa-bug-slash"></i>
);
